import React, { ReactElement } from 'react';
import { Heading } from 'idsk-react-components';
import NavrhAktuEu from '../../model/NavrhAktuEu';
import NavrhAktuEuDetailRow from './component/NavrhAktuEuDetailRow';
import mapDate from '../../function/mapDate';
import './navrhAktuEuDetail.scss';
import PrilohaAktuEuComponent from './component/PrilohaAktuEuComponent';

interface Props {
  aktEu: NavrhAktuEu;
}

const NavrhAktuEuDetail = ({ aktEu }: Props): ReactElement => (
  <div className="navrh-aktu-eu-detail">
    <NavrhAktuEuDetailRow
      header="Identifikátor aktu"
      data={aktEu?.aktId}
    />
    <NavrhAktuEuDetailRow
      header="Medziinštitucionálny kód"
      data={aktEu?.medziinstitucionalnyKod}
    />
    <NavrhAktuEuDetailRow
      header="Názov aktu EÚ"
      data={aktEu?.name}
    />
    <NavrhAktuEuDetailRow
      header="Dátum prijatia aktu"
      data={aktEu?.datumPrijatiaAktu ? mapDate(aktEu?.datumPrijatiaAktu) : undefined}
    />
    <NavrhAktuEuDetailRow
      header="Inštitúcia"
      data={aktEu?.institucia?.nazov}
    />
    <NavrhAktuEuDetailRow
      header="Typ aktu"
      data={aktEu?.typ?.nazov}
    />
    <NavrhAktuEuDetailRow
      header="Číslo procesu"
      data={aktEu?.legislativnyMaterial?.cisloLegMaterialu}
      link={aktEu?.legislativnyMaterial?.redirectUrl}
    />
    <NavrhAktuEuDetailRow
      header="Názov procesu"
      data={aktEu?.legislativnyMaterial?.name}
      link={aktEu?.legislativnyMaterial?.redirectUrl}
    />
    <>
      {aktEu.prilohaAktEuList.length > 0 && (
      <Heading className="prilohy-aktu-eu__heading" size="m">Prílohy</Heading>
      )}
      {aktEu.prilohaAktEuList?.map((priloha, index) => (
        <PrilohaAktuEuComponent
              /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          priloha={priloha}
        />
      ))}
    </>
  </div>
);

export default NavrhAktuEuDetail;
